var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgE(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 55,
    viewBox: "0 0 40 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 55,
    fill: "#1F1F1F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 864"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 348",
    d: "M37 3H3V37L20 51L37 37V3Z",
    fill: "#230047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 348 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H40V38.4158L20 54.8864L0 38.4158V0ZM37 3V37L20 51L3 37V3H37Z",
    fill: "#410096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 372",
    d: "M20 21L3 11V16L20 26L37 16V11L20 21Z",
    fill: "#F0B90B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 373",
    d: "M20 31L3 21V26L20 36L37 26V21L20 31Z",
    fill: "#F0B90B"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgE);
export default __webpack_public_path__ + "static/media/E.57640f7f.svg";
export { ForwardRef as ReactComponent };